import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white p-6 text-center mt-auto"
      style={{
        background: 'rgba(0, 0, 10, 0.4)'
      }}    
    >
      <p>&copy; 2025-2026 CSOAUTOMATION™. All rights reserved.</p>
      <p> 
        <Link to="/contact" className="hover:opacity-80 underline">Contact Us</Link> | Built with Python+React.
      </p>
    </footer>
  );
}
